@if (slides.length > 0) {
    <section class="hscWrap" aria-label="featured templates">
        <header class="hscHead">
            <div class="hscHeadText">
                <span class="hscEyebrow">{{ 'ai.home_show_eyebrow' | transloco }}</span>
                <h2 class="hscTitle">{{ 'ai.home_show_title' | transloco }}</h2>
            </div>
            <div class="hscHeadCtrls">
                <button type="button" class="hscNav" (click)="prev()" [attr.aria-label]="'previous'">
                    <mat-icon>chevron_left</mat-icon>
                </button>
                <button type="button" class="hscNav" (click)="next()" [attr.aria-label]="'next'">
                    <mat-icon>chevron_right</mat-icon>
                </button>
            </div>
        </header>

        <div class="hscStage"
             (mouseenter)="onMouseEnter()"
             (mouseleave)="onMouseLeave()">
            @for (item of visibleSlides; track item.slide.sceneName) {
                <figure class="hscSlide"
                        [class.hscSlideActive]="item.idx === activeIdx"
                        [class.hscSlideReady]="isLoaded(item.slide)"
                        [attr.aria-hidden]="item.idx !== activeIdx">
                    <div class="hscSlideMedia">
                        @if (shouldLoad(item.slide)) {
                            <img class="hscSlideImg"
                                 [src]="item.slide.url"
                                 [alt]="item.slide.sceneTitle"
                                 (load)="onImgLoad(item.slide)"
                                 (error)="onImgError(item.slide)"
                                 draggable="false" />
                        }
                        <div class="hscSlideShade" aria-hidden="true"></div>

                        @if (item.idx === activeIdx && !isLoaded(item.slide)) {
                            <div class="hscLoader" role="status" aria-live="polite">
                                <div class="hscLoaderShimmer" aria-hidden="true"></div>
                                <div class="hscLoaderOrb" aria-hidden="true">
                                    <span class="hscLoaderOrbRing"></span>
                                    <span class="hscLoaderOrbRing hscLoaderOrbRing2"></span>
                                    <span class="hscLoaderOrbCore"></span>
                                </div>
                                <div class="hscLoaderText">
                                    <span class="hscLoaderTextLead">{{ 'ai.home_show_loading' | transloco }}</span>
                                    <span class="hscLoaderTextMeta">{{ item.slide.folder }}</span>
                                </div>
                                <div class="hscLoaderDots" aria-hidden="true">
                                    <span class="hscLoaderDot"></span>
                                    <span class="hscLoaderDot"></span>
                                    <span class="hscLoaderDot"></span>
                                </div>
                            </div>
                        }
                    </div>
                    <figcaption class="hscSlideCap">
                        <span class="hscSlideTag">{{ item.slide.folder }}</span>
                        <span class="hscSlideName">{{ item.slide.sceneTitle }}</span>
                    </figcaption>
                </figure>
            }

            <button type="button" class="hscCta" (click)="useThisTemplate()">
                <mat-icon>auto_awesome</mat-icon>
                <span>{{ 'ai.home_show_cta' | transloco }}</span>
            </button>

            @if (slides.length <= 12) {
                <div class="hscDots" role="tablist">
                    @for (slide of slides; track slide.sceneName; let i = $index) {
                        <button type="button"
                                class="hscDot"
                                [class.hscDotActive]="i === activeIdx"
                                (click)="pickIdx(i)"
                                [attr.aria-label]="'slide ' + (i + 1)"
                                role="tab">
                            <span class="hscDotInner"></span>
                        </button>
                    }
                </div>
            } @else {
                <div class="hscCounter" aria-live="polite">
                    <span class="hscCounterVal">{{ activeIdx + 1 }}</span>
                    <span class="hscCounterSep">/</span>
                    <span class="hscCounterMax">{{ slides.length }}</span>
                </div>
            }
        </div>
    </section>
}
